module.exports = __webpack_public_path__ + "img/avatar7.3e6e496a.jpg";